﻿export default function () {
    console.errorIf = function (condition, ...data) {
        if (condition) {
            console.error(...data);
        };
    };
    console.infoIf = function (condition, ...data) {
        if (condition) {
            console.info(...data);
        };
    };
    console.logIf = function (condition, ...data) {
        if (condition) {
            console.log(...data);
        };
    };
    console.warnIf = function (condition, ...data) {
        if (condition) {
            console.warn(...data);
        };
    };
}